export const STOPALARM = '/stopalarm/:slug';
export const STOPALARMPAGE = '/stopalarmpage/:slug';